export default __webpack_public_path__ + "static/media/BlissPro-Regular.a722cdb4.woff";